import type { GfActionKey } from "../../../../types/gifting";
import { ACTION_GROUPS, ACTION_META } from "../../../../lib/giftingRules";

/** 「今日やること」カード（README ①b）。3グループ・単一選択・0件は薄く。選択は nav.state.act */
export function TodayChips({
  counts,
  todayTotal,
  activeTotal,
  waitCount,
  act,
  hasFilter,
  onSelect,
  onClear,
}: {
  counts: Record<GfActionKey, number>;
  todayTotal: number;
  activeTotal: number;
  waitCount: number;
  act: GfActionKey | null;
  /** チップ・保存フィルタ・検索のどれかで絞り込み中 */
  hasFilter: boolean;
  onSelect: (key: GfActionKey | null) => void;
  onClear: () => void;
}) {
  return (
    <section className="gf-today" aria-label="今日やること">
      <div className="gf-today-title">
        <span className="gf-today-h">今日やること</span>
        <span className="gf-today-sub">
          <span className="gf-mono gf-today-n">{todayTotal}</span> 件 / 進行 {activeTotal}
        </span>
      </div>
      {ACTION_GROUPS.map((g) => (
        <div className="gf-today-group" key={g.group}>
          <span className="gf-today-glabel">{g.label}</span>
          {g.keys.map((k) => {
            const meta = ACTION_META[k];
            const n = counts[k] ?? 0;
            const on = act === k;
            return (
              <button
                type="button"
                key={k}
                className={`gf-today-chip is-t${meta.tier}${on ? " is-on" : ""}${n === 0 && !on ? " is-zero" : ""}`}
                aria-pressed={on}
                title={meta.desc}
                onClick={() => onSelect(on ? null : k)}
              >
                <span className="gf-today-dot" />
                <span>{meta.label}</span>
                <span className="gf-mono gf-today-count">{n}</span>
              </button>
            );
          })}
        </div>
      ))}
      <div className="gf-today-tail">
        <span>待ち {waitCount}</span>
        {hasFilter && (
          <button type="button" className="gf-today-clear" onClick={onClear}>
            絞り込み解除
          </button>
        )}
      </div>
    </section>
  );
}
